import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import MateriaPeriodoForm from './MateriaPeriodoForm';
import {
  get,
  save,
  fetchFormDatas,
  fetchSubjectsByMeshId,
  fetchSubjectsScheduleBySubjectPeriodId,
  getSubjectStudents,
  downloadSubjectStudentsScore,
} from '../../../redux/actions/materiaPeriodoActions';

import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../helpers/notification';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

class MateriaPeriodoContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mallas: [],
      materias: [],
      periodos: [],
      profesores: [],
      tipoActividadAcademicaHorarios: [],
      diasSemana: [],
      materiaPeriodo: null,
      loading: false,
      horarios: [],
      horarioChanged: 0,

      loadingAlumnosMateria: false,
      items: [],
      totalItemsCount: 0,
      filters: {
        page: 1,
        pageSize: 20,
        numeroDocumento: '',
        nombreAlumno: '',
        apellidoAlumno: '',
      },
    };

    this.downloadAlumnosMateriaNotas.bind(this);
  }

  componentDidMount() {
    this.fetchDatasList();
    this.updateSubjectsScheduleTable();
  }

  downloadAlumnosMateriaNotas = () => {
    const { id } = this.props;
    this.setState({ loadingAlumnosMateria: true });
    downloadSubjectStudentsScore({
      id,
      onSuccess: () => {
        this.setState({ loadingAlumnosMateria: false });
        createSuccessMessage('Lista descargada exitosamente');
      },
      onError: () => {
        this.setState({ loadingAlumnosMateria: false });
        createErrorMessage('Error al intentar descargar la lista de calificaciones alumnos');
      },
    });
  }

  fetchCurrentRecord = () => {
    const { id, history } = this.props;
    const state = {};

    if (!id) {
      this.setState({
        materiaPeriodo: {
          id: 0,
          date: new Date().toISOString(),
          mallaId: null,
          malla: { value: 0, label: '-' },
          periodoId: null,
          periodo: { value: 0, label: '-' },
          materia: { value: 0, label: '-' },
          materiaMalla: { value: 0, label: '-' },
          profesorAuxiliar1: { value: 0, label: '-' },
          profesorAuxiliar2: { value: 0, label: '-' },
          profesorAuxiliar3: { value: 0, label: '-' },
          utilizaPorcentajePesoMateria: false,
          ...state,
        },
      });

      return;
    }

    get({
      id,
      onSuccess: (materiaPeriodo) => {
        this.setState({
          materiaPeriodo: {
            ...materiaPeriodo,
            ...state,
          },
        });
      },
      onError: (error) => {
        if (error && error.status === 404) {
          createErrorMessage('La materia periodo no existe');
          history.push('/pages/subjects-periods');
        } else {
          createErrorMessage('Error al intentar cargar los datos de la materia periodo');
        }
      },
    });
  }

  fetchDatasList = () => {
    fetchFormDatas({
      onSuccess: ({
        mallas,
        periodos,
        profesores,
        tipoActividadAcademicaHorarios,
        diasSemana,
      }) => {
        const state = {
          mallas,
          periodos,
          profesores,
          tipoActividadAcademicaHorarios,
          diasSemana,
        };

        this.setState(state);
        this.fetchCurrentRecord();
      },
      onError: () => createErrorMessage('Error al intentar cargar los datos requeridos'),
    });
  }

  updateAlumnosMateria = (page, pageSize, filters) => {
    const { id } = this.props;

    this.setState({
      loadingAlumnosMateria: true,
      filters: filters || {},
    });

    getSubjectStudents({
      filters,
      id,
      onSuccess: ({ materias: items }) => {
        this.setState({
          loadingAlumnosMateria: false,
          items,
          totalItemsCount: items.length,
        });
      },
      onError: () => {
        this.setState({
          items: [],
          loadingAlumnosMateria: false,
        });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  handleAddSubjectsSchedule = () => {
    const { horarios = [] } = this.state;

    const newIndex = horarios.length === 0 ? 0 : (Math.max(...horarios.map(({ index }) => index)) + 1);

    this.setState({
      horarios: [
        ...horarios,
        {
          id: 0,
          index: newIndex,
          materiaPeriodo: '',
          profesor: {
            value: 0,
            label: '-',
            parentId: 0,
            item: null,
          },
          dia: {
            value: 0,
            label: '-',
            parentId: 0,
            item: null,
          },
          horaInicio: '00:00',
          horaFin: '00:00',
          aula: '',
          tipoActividadAcademicaHorario: {
            value: 0,
            label: '-',
            parentId: 0,
            item: null,
          },
        },
      ],
    });
  }

  handleDeleteSubjectSchedule = ({ index }) => {
    const { horarios = [] } = this.state;
    const newArray = horarios.map(h => ({
      ...h,
      deleted: h.deleted || h.index === index,
    }));

    this.setState({ horarios: newArray });
  }

  fetchSubjects = (meshId) => {
    fetchSubjectsByMeshId({
      meshId,
      onSuccess: (materias) => {
        this.setState({ materias });
      },
      onError: () => createErrorMessage('Error al intentar cargar las materias'),
    });
  }

  handleSubmit = (values) => {
    if (!values) return;

    const {
      id,
      materia: { value: materiaId },
      profesor: { value: profesorId },
      malla: { value: mallaId },
      materiaMalla: { value: materiaMallaId },
      periodo: { value: periodoId },
      profesorAuxiliar1,
      profesorAuxiliar2,
      profesorAuxiliar3,
      horarios,
      utilizaPorcentajePesoMateria,
      editarAsistencias,
      seccion,
    } = values;

    const params = {
      id,
      mallaId,
      materiaMallaId,
      materiaId,
      profesorId,
      periodoId,
      profesorAuxiliar1Id: profesorAuxiliar1 ? profesorAuxiliar1.value : 0,
      profesorAuxiliar2Id: profesorAuxiliar2 ? profesorAuxiliar2.value : 0,
      profesorAuxiliar3Id: profesorAuxiliar3 ? profesorAuxiliar3.value : 0,
      horarios,
      utilizaPorcentajePesoMateria,
      editarAsistencias,
      seccion,
    };

    save(params, {
      onSuccess: () => {
        createSuccessMessage('Materia por periodo guardada exitosamente');

        const { history } = this.props;
        history.push('/pages/subjects-periods');
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la materia periodo');
        }
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleOnFilterChanges = (objectKey, idKey, item) => {
    let { materiaPeriodo } = this.state;

    materiaPeriodo = {
      ...materiaPeriodo,
      [idKey]: item.value,
      [objectKey]: item,
    };

    const {
      malla: { value: mallaId },
    } = materiaPeriodo;

    this.setState({ materiaPeriodo });

    if (mallaId) {
      this.fetchSubjects(mallaId);
    }
  }

  updateSubjectsScheduleTable = () => {
    const { id } = this.props;

    if (!id) {
      this.setState({
        horarios: [],
      });

      return;
    }

    this.setState({
      loading: true,
    });

    fetchSubjectsScheduleBySubjectPeriodId({
      subjectId: id,
      onSuccess: (horarios) => {
        this.setState({
          loading: false,
          horarios: horarios.map((h, index) => ({ ...h, index })),
        });
      },
      onError: (error) => {
        this.setState({ horarios: [], loading: false });
        if (error && error.status === 404) {
          createErrorMessage('La horario de clases no existe');
        } else {
          createErrorMessage('Error al intentar cargar los datos del horario de clases');
        }
      },
    });
  }

  handleChangeText = (e, index) => {
    const { horarios } = this.state;

    const value = e.target.type === 'number' ? Number(e.target.value) : `${e.target.value}`.trim();

    const newHorarios = [...horarios];
    newHorarios[index] = {
      ...newHorarios[index],
      ...{
        [e.target.name.split('.')[1]]: value,
      },
    };

    this.setState({ horarios: newHorarios });
  };

  handleChangeSelect = ({ option, name, index }) => {
    this.setState({ loading: true });

    const { horarios } = this.state;
    const newHorarios = [...horarios];
    const data = {
      [name]: option,
      index,
    };

    newHorarios[index] = {
      ...newHorarios[index],
      ...data,
    };

    this.setState({
      horarios: newHorarios,
      loading: false,
      horarioChanged: new Date().getTime(),
    });
  };

  render() {
    const { id, history } = this.props;

    const {
      materiaPeriodo,
      materias,
      profesores,
      mallas,
      periodos,
      tipoActividadAcademicaHorarios,
      diasSemana,
      loading,
      horarios,
      horarioChanged,
      loadingAlumnosMateria,
      items,
      filters,
      totalItemsCount,
    } = this.state;

    const showForm = profesores && mallas && materiaPeriodo && tipoActividadAcademicaHorarios.length;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} materia periodo
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la materia periodo
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {
              !showForm || loading
                ? (<LoadingSpinner />)
                : (
                  <MateriaPeriodoForm
                    {...materiaPeriodo}
                    onSubmit={this.handleSubmit}
                    onBack={this.handleOnBack}
                    loading={loading}
                    initialValues={materiaPeriodo}
                    materiaPeriodo={materiaPeriodo}
                    history={history}
                    profesores={profesores}
                    materias={materias}
                    mallas={mallas}
                    periodos={periodos}
                    tipoActividadAcademicaHorarios={tipoActividadAcademicaHorarios}
                    diasSemana={diasSemana}
                    subjectId={Number(id)}

                    horarioChanged={horarioChanged}

                    onChangeText={this.handleChangeText}
                    onChangeSelect={this.handleChangeSelect}

                    onFilterChanges={this.handleOnFilterChanges}
                    onAddSubjectsSchedule={this.handleAddSubjectsSchedule}
                    onDeleteSubjectSchedule={this.handleDeleteSubjectSchedule}
                    onGetAlumnosMateria={this.updateAlumnosMateria}
                    onDownloadAlumnosMateriaNotas={this.downloadAlumnosMateriaNotas}

                    horarios={horarios}

                    loadingAlumnosMateria={loadingAlumnosMateria}
                    items={items}
                    totalItemsCount={totalItemsCount}
                    filters={filters}
                    enableReinitialize
                  />
                )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

MateriaPeriodoContainer.propTypes = {
  id: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default MateriaPeriodoContainer;
